import { render, staticRenderFns } from "./promotion_set.vue?vue&type=template&id=5f7520b8&scoped=true"
import script from "./promotion_set.vue?vue&type=script&lang=ts"
export * from "./promotion_set.vue?vue&type=script&lang=ts"
import style0 from "./promotion_set.vue?vue&type=style&index=0&id=5f7520b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7520b8",
  null
  
)

export default component.exports